const DavidChants = () => {
  return (
    <div>
      <h1>David Chants</h1>
      <p>David Chants is a great guy.</p>
    </div>
  );
};

export default DavidChants;